import React from 'react';
import { useForm } from 'react-hook-form';
import Button from '../UI/Button';

const SalaryForm = ({ salary, user, onSubmit, onCancel }) => {
  const { register, handleSubmit, watch, formState: { errors } } = useForm({
    defaultValues: salary || {
      userId: user.id,
      baseSalary: 0,
      housingAllowance: 0,
      transportAllowance: 0,
      otherAllowances: 0,
      deductions: 0,
      currency: 'USD',
      effectiveDate: new Date().toISOString().split('T')[0]
    }
  });

  const baseSalary = parseFloat(watch('baseSalary') || 0);
  const housing = parseFloat(watch('housingAllowance') || 0);
  const transport = parseFloat(watch('transportAllowance') || 0);
  const other = parseFloat(watch('otherAllowances') || 0);
  const deductions = parseFloat(watch('deductions') || 0);
  
  const totalSalary = baseSalary + housing + transport + other - deductions;
  const userName = user.fullName || user.full_name || 'Employee';

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
      <div className="bg-blue-50 p-4 rounded-lg mb-4">
        <h3 className="text-sm font-medium text-blue-900">Setting Salary for: {userName}</h3>
        <p className="text-xs text-blue-700">{user.email}</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Base Salary *
          </label>
          <input
            type="number"
            step="0.01"
            {...register('baseSalary', { required: 'Base salary is required', min: 0 })}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-primary-500 focus:border-primary-500"
          />
          {errors.baseSalary && (
            <p className="mt-1 text-sm text-red-600">{errors.baseSalary.message}</p>
          )}
        </div>

        <div>
           <label className="block text-sm font-medium text-gray-700 mb-1">
            Currency
          </label>
          <select
            {...register('currency')}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-primary-500 focus:border-primary-500"
          >
            <option value="USD">USD ($)</option>
            <option value="INR">INR (₹)</option>
            <option value="EUR">EUR (€)</option>
            <option value="AED">AED (د.إ)</option>
            <option value="GBP">GBP (£)</option>
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Housing Allowance
          </label>
          <input
            type="number"
            step="0.01"
            {...register('housingAllowance')}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-primary-500 focus:border-primary-500"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Transport Allowance
          </label>
          <input
            type="number"
            step="0.01"
            {...register('transportAllowance')}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-primary-500 focus:border-primary-500"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Other Allowances
          </label>
          <input
            type="number"
            step="0.01"
            {...register('otherAllowances')}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-primary-500 focus:border-primary-500"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1 text-red-600">
            Standard Deductions
          </label>
          <input
            type="number"
            step="0.01"
            {...register('deductions')}
            className="w-full px-3 py-2 border border-red-300 rounded-lg focus:ring-red-500 focus:border-red-500"
          />
        </div>
      </div>

      <div className="border-t border-gray-200 pt-4 mt-4">
        <div className="flex justify-between items-center text-lg font-bold">
          <span>Net Salary:</span>
          <span className={totalSalary >= 0 ? "text-green-600" : "text-red-600"}>
            {totalSalary.toLocaleString()}
          </span>
        </div>
      </div>

      <div className="flex justify-end space-x-3 pt-4">
        <Button variant="outline" onClick={onCancel} type="button">
          Cancel
        </Button>
        <Button type="submit">
          Save Structure
        </Button>
      </div>
    </form>
  );
};

export default SalaryForm;